module.exports = __webpack_public_path__ + "img/ehs-1.bb8eb10d.png";